import React from 'react';

export default function AnalyticsOverview() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-gray-900">Analytics Overview</h1>
      <p className="text-sm text-gray-500 mt-2">
        This page is under construction.
      </p>
    </div>
  );
}